import { svg } from 'lit';

export const mailIcon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21 5.25H3C2.58579 5.25 2.25 5.58579 2.25 6V18C2.25 18.4142 2.58579 18.75 3 18.75H21C21.4142 18.75 21.75 18.4142 21.75 18V6C21.75 5.58579 21.4142 5.25 21 5.25ZM20.25 6.75V7.56L12 12.14L3.75 7.56V6.75H20.25ZM3.75 17.25V9.25L11.64 13.63C11.8669 13.7564 12.1431 13.7564 12.37 13.63L20.26 9.25V17.25H3.75Z" fill="#786E5C"/>
</svg>`;
